const ethers = require("ethers");

class Contracts {
  contracts;
  nameByAddress;
  signerOrProvider;

  // The first condition assumes the use of ethers v5 in our backend, while we are using ethers v6 here.
  constructor(signerOrProvider, networkName, { networkUrl = "" } = {}) {
    this.signerOrProvider = signerOrProvider ? signerOrProvider : new ethers.providers.JsonRpcProvider(networkUrl);

    this.contracts = loadAllDeploymentsFromFile(networkName, this.signerOrProvider);

    this.nameByAddress = {};

    for (const [name, contract] of Object.entries(this.contracts)) this.nameByAddress[contract.address] = name;
  }

  static init(signerPrivateKey, networkName, networkUrl) {
    const provider = new ethers.providers.JsonRpcProvider(networkUrl);
    const signer = new ethers.Wallet(signerPrivateKey, provider);

    return new Contracts(signer, networkName);
  }

  getContractByName(name) {
    const contract = this.contracts[name];
    if (!contract) throw new Error(`Unknown contract name ${name}`);
    return contract;
  }

  getContractByNameSafe(name) {
    return this.contracts[name];
  }

  getContractByAddress(address) {
    const name = this.getNameByAddress(address);
    return this.getContractByName(name);
  }

  getContractByAddressSafe(address) {
    const name = this.getNameByAddress(address);
    return this.getContractByNameSafe(name);
  }

  getNameByAddress(address) {
    const name = this.nameByAddress[address];
    if (!name) throw new Error(`Unknown contract address ${address}`);
    return name;
  }

  getNameByAddressSafe(address) {
    return this.nameByAddress[address];
  }

  static getContract(networkName, contractName) {
    const deployments = require(`../../deployments/${networkName}.json`);
    return { address: deployments[contractName].address, abi: deployments[contractName].abi };
  }

  static getAllContractsAbiWithAddresses(networkName) {
    const deployments = require(`../../deployments/${networkName}.json`);
    const result = {};

    Object.values(deployments).forEach((deployment) => {
      result[deployment.address] = deployment.abi;
    });

    return result;
  }
}

function loadAllDeploymentsFromFile(networkName, signer) {
  const deployments = require(`../../deployments/${networkName}.json`);
  const result = {};

  for (const name of Object.keys(deployments)) {
    const deployment = deployments[name];
    result[name] = new ethers.Contract(deployment.address, deployment.abi, signer);
  }
  return result;
}

module.exports = { Contracts, loadAllDeploymentsFromFile };
